import c from "./TableContainer.module.scss";
import Pagination from "../utils/Pagination";
import Table from "../utils/table/Table";
import CrudPlanModal from "../popups/CrudPlanPopup";
import ConfirmModal from "../popups/ConfirmPopup";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DuplicatePlanModal from "../plans/DuplicatePlan";
import LoadingBox from "../loading/LoadingBox";
import EmptyBox from "../emptystate/EmptyBox";
import MoreOptions from "../utils/more-options/MoreOptions";
import { OrganizationsPickerContextProvider } from "../../context/organizations-picker.context";
import EmailMassiveModal from "../popups/plan-template/EmailMassivePopup";
import DownloadMultipleModal from "../popups/DownloadMultiplePopup";
import { formatTemplatePlanDownloadObject } from "../../helper/formatter.helper";
import useTemplatePlanActionsHook from "../../hooks/use-template-plan-actions.hook";
import LoaderPage from "../utils/LoaderPage";
import Chip from "../chip/Chip";
import { PlanHierarchyIcon } from "../plans/PlanHierarchyIcon";

function TableTemplatePlans({
	isLoading,
	plans,
	updatePage,
	pageData,
	onInsert,
	onEdit,
	onDelete,
	onClone,
	onSearch,
	isInit,
}) {
	const [activeOrganizations, setActiveOrganizations] = useState([]);

	const [organizationTypes, setOrganizationTypes] = useState([]);

	const [selectedPlan, setSelectedPlan] = useState(null);

	const [deleteItem, setDeleteItem] = useState(null);

	const [duplicateItem, setDuplicateItem] = useState(null);

	const [editPlan, setEditPlan] = useState(null);

	const {
		createDownloadTemplateHandler,
		getAllOrganizationTypesHandler,
		getAllOrganizationsHandler,
		isLoading: isLoadingAction,
		isModalOpen,
		updateModalState,
		getTemplatePlanHandler,
		downloadDifferenceHandler,
		deletePlanHandler,
	} = useTemplatePlanActionsHook();

	/**
	 * Edit request
	 * @param {*} plan
	 */
	const openCrudPlan = (plan = null) => {
		setEditPlan(plan);
		updateModalState({ crud: true });
	};

	/**
	 * Request Delete
	 * @param {*} item
	 */
	const deleteRequest = (item) => {
		setDeleteItem(item);
		updateModalState({ delete: true });
	};

	/**
	 * Request duplicate
	 * @param {*} item
	 */
	const duplicateRequest = (item) => {
		setDuplicateItem(item);
		updateModalState({ duplicate: true });
	};

	/**
	 * insert callback
	 * @param {I} res
	 */
	const onInsertHandler = (res) => {
		updateModalState({ crud: false });
		onInsert(res);
	};

	/**
	 * edit callback
	 * @param {*} res
	 */
	const onEditHandler = (res) => {
		updateModalState({ crud: false });
		onEdit(res);
	};

	/**
	 * Delete handler
	 */
	const onDeleteHandler = () => {
		deletePlanHandler(deleteItem.id, () => {
			updateModalState({ delete: false });
			onDelete();
		});
	};

	/**
	 * Clone Handler
	 */
	function onCloneHandler() {
		updateModalState({ duplicate: false });
		onClone();
	}

	/**
	 * Update active organization types
	 * @returns {Promise<void>}
	 */
	const updateOrganizationTypesHandler = async () => {
		setOrganizationTypes([]);
		const types = await getAllOrganizationTypesHandler();
		setOrganizationTypes(types);
	};

	/**
	 * Update active organizations
	 * @param plan
	 * @returns {Promise<void>}
	 */
	const updateActiveOrganizationsHandler = async (plan) => {
		setActiveOrganizations([]);
		const organizations = await getAllOrganizationsHandler(plan);
		setActiveOrganizations(organizations);
	};

	/**
	 * Download Request
	 * @param plan
	 * @returns {Promise<void>}
	 */
	const downloadMassiveRequestHandler = async (plan) => {
		setSelectedPlan(plan);
		updateActiveOrganizationsHandler(plan);
		const data = await getTemplatePlanHandler(plan.id, {
			include: ["requirementStatuses"],
		});
		if (data) {
			setSelectedPlan(data);
			updateModalState({ downloadMassive: true });
		} else {
			setSelectedPlan(null);
		}
	};

	/**
	 * Email request
	 * @param plan
	 * @returns {Promise<void>}
	 */
	const emailMassiveRequestHandler = async (plan) => {
		setSelectedPlan(plan);
		await updateActiveOrganizationsHandler(plan);
		updateModalState({ emailMassive: true });
	};

	useEffect(() => {
		updateOrganizationTypesHandler();
	}, []);

	return (
		<>
			<div className={c.main_intro}>
				<div className={c.left_content}>
					<div className={c.title}>Piani</div>
				</div>
				<div className={c.right_content}>
					<div className="wrap_input_landing icon">
						<input
							type="text"
							onChange={(e) => onSearch(e.target.value)}
							className="landing"
							placeholder="Ricerca..."
						/>
						<span className="icon_16 default search"></span>
					</div>
					<button
						type="button"
						className="button fill primary small"
						onClick={() => openCrudPlan()}
					>
						<div className="load_content">Nuovo</div>
					</button>
				</div>
			</div>

			<div className="relative">
				{plans.length > 0 ? (
					<div className="fade_in">
						<Table>
							<Table.Head>
								<Table.Column>Anno</Table.Column>
								<Table.Column>Nome</Table.Column>
								<Table.Column>Tag</Table.Column>
								<Table.Column>Contenuto</Table.Column>
								<Table.Column>Enti abilitati</Table.Column>
								<Table.Column>Attivo</Table.Column>
								<Table.Column>In lavorazione</Table.Column>
								<Table.Column></Table.Column>
							</Table.Head>
							<Table.Body>
								{plans.map((el, index) => (
									<Table.Row key={index} className="action_hover_list">
										<Table.Cell width={80}>{el.year}</Table.Cell>
										<Table.Cell width={500}>
											<div className="max-w-[400px] flex align-middle">
												<div className="mr-[13px]">
													<PlanHierarchyIcon level={el.diff_download?.length && "branch"} />
												</div>
												<div>
													<div className="title">{el.name}</div>
													<div className="subtitle line-clamp-1">{el.description}</div>
												</div>
											</div>
										</Table.Cell>
										<Table.Cell width={250}>
											<div className="flex items-center gap-3">
												{!el?.tags?.length && "–"}
												{el?.tags?.slice(0, 2).map((tag) => (
													<Chip
														label={tag.label}
														key={tag.id}
														className="text-white font-semibold ring-0"
														style={{ backgroundColor: tag.color }}
													/>
												))}
												{el.tags.length > 2 && (
													<div
														data-tooltip-id="tooltip_small_top"
														data-tooltip-offset={10}
														data-tooltip-position-strategy="fixed"
														data-tooltip-content={el.tags
															.slice(2)
															.map((tag) => tag.label)
															.join("\n")}
													>
														<Chip
															label={`+${el.tags.length - 2}`}
															className="text-interactive-100 font-semibold ring-0 bg-interactive-10"
														/>
													</div>
												)}
											</div>
										</Table.Cell>

										<Table.Cell width={250}>
											<div className="spacing_items">
												<div className="main_icon_text">
													<span className="icon_16 default folder"></span>
													{el.template_chapters_count}
												</div>
												<div className="main_icon_text">
													<span className="icon_16 default text_box"></span>
													{el.template_chapter_contents_count}
												</div>
												<div className="main_icon_text">
													<span className="icon_16 default layers"></span>
													{el.template_goals_count}
												</div>
												<div className="main_icon_text">
													<span className="icon_16 default layer"></span>
													{el.template_requirements_count}
												</div>
											</div>
										</Table.Cell>

										<Table.Cell width={100}>
											<div className="main_icon_text">
												<span className="icon_16 default entity"></span>
												{el.active_organization_plans_count}
											</div>
										</Table.Cell>

										<Table.Cell width={100}>
											<div className="main_icon_text">
												<span
													className={
														"icon_16 default icon_mask " +
														(el.active ? "check !bg-green-100" : "cross !bg-red-100")
													}
												></span>
												{el.active ? "Si" : "No"}
											</div>
										</Table.Cell>

										<Table.Cell width={100}>
											<div className="main_icon_text">
												<span
													className={
														"icon_16 default icon_mask " +
														(el.working ? "check !bg-green-100" : "cross !bg-red-100")
													}
												></span>
												{el.working ? "Si" : "No"}
											</div>
										</Table.Cell>

										<Table.Cell width={40}>
											<div className="spacing_items">
												<MoreOptions
													options={[
														...(el.diff_download?.length
															? [
																	{
																		label: "Scarica differenze",
																		icon: "icon_16 icon_mask !bg-interactive-100 default download_diff",
																		onClick: () =>
																			downloadDifferenceHandler(el.diff_download, el.diff_filename),
																	},
																]
															: []),
														{
															label: "Scarica piani di enti abilitati",
															icon: "icon_16 icon_mask !bg-interactive-100 default download",
															onClick: () => downloadMassiveRequestHandler(el),
														},
														{
															label: "Scarica template",
															icon: "icon_16 icon_mask !bg-interactive-100 default piano",
															onClick: () => createDownloadTemplateHandler(el),
														},
														{
															label: "Invio massivo piani",
															icon: "icon_16 icon_mask !bg-interactive-100 default send",
															onClick: () => emailMassiveRequestHandler(el),
														},
														{
															label: "Duplica",
															icon: "icon_16 icon_mask !bg-interactive-100 default duplicate",
															onClick: () => duplicateRequest(el),
														},
														{
															label: "Modifica",
															icon: "icon_16 icon_mask !bg-interactive-100 default edit",
															onClick: () => openCrudPlan(el),
														},
														{
															label: "Elimina",
															icon: "icon_16 icon_mask !bg-interactive-100 default delete",
															onClick: () => deleteRequest(el),
														},
													]}
												/>

												<Link
													to={`/admin/plans/template/detail/${el.id}`}
													className="button fill tertiary x_small"
												>
													Dettaglio
												</Link>
											</div>
										</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>
						</Table>

						<Pagination
							last={pageData.last}
							current={pageData.current}
							onChange={updatePage}
							total={pageData.total}
						/>
					</div>
				) : (
					isInit && (
						<EmptyBox
							icon="icon_75 default archive_plan"
							title="Nessun risultato trovato"
							description="Qui visualizzerai la lista di tutti i piani creati"
						/>
					)
				)}
				{isLoading.length > 0 && <LoadingBox blocked={!isInit} />}
			</div>

			<CrudPlanModal
				open={isModalOpen.crud}
				setOpen={(bool) => updateModalState({ crud: bool })}
				planModel={editPlan}
				onInsert={onInsertHandler}
				onEdit={onEditHandler}
			/>

			<DuplicatePlanModal
				open={isModalOpen.duplicate}
				setOpen={(open) => updateModalState({ duplicate: open })}
				planModel={duplicateItem}
				onSuccess={onCloneHandler}
			/>

			<OrganizationsPickerContextProvider
				organizations={activeOrganizations}
				types={organizationTypes}
			>
				<EmailMassiveModal
					open={isModalOpen.emailMassive}
					setOpen={(open) => updateModalState({ emailMassive: open })}
				/>
			</OrganizationsPickerContextProvider>

			<DownloadMultipleModal
				organizations={activeOrganizations}
				organizationTypes={organizationTypes}
				open={isModalOpen.downloadMassive}
				setOpen={(open) => updateModalState({ downloadMassive: open })}
				template={formatTemplatePlanDownloadObject(selectedPlan?.contents ?? [])}
				loadingData={{
					organizations: isLoadingAction.activeOrganization,
					types: isLoadingAction.organizationTypes,
				}}
				statuses={selectedPlan?.requirement_statuses}
				templateId={selectedPlan?.id}
			/>

			<ConfirmModal
				open={isModalOpen.delete}
				setOpen={(open) => updateModalState({ delete: open })}
				title="Conferma eliminazione"
				icon="icon_16 default piano"
				subtitle={deleteItem?.name && deleteItem.name}
				description={deleteItem?.description && deleteItem.description}
				counterCaphters={deleteItem?.chapters_count && deleteItem.chapters_count}
				counterContents={deleteItem?.chapter_contents_count && deleteItem.chapter_contents_count}
				counterGoals={deleteItem?.goals_count && deleteItem.goals_count}
				counterActions={deleteItem?.requirements_count && deleteItem.requirements_count}
				alertMessage="Attenzione! Questa operazione è irreversibile! <b>Sei sicuro di procedere?</b>"
				ctaLabel="Elimina"
				onConfirm={onDeleteHandler}
			/>

			{(isLoadingAction.templatePlan ||
				isLoadingAction.activeOrganization ||
				isLoadingAction.downloadTemplate) && (
				<LoaderPage
					title={
						selectedPlan
							? `Recupero dati del piano: ${selectedPlan.name}`
							: "Recupero dati in corso..."
					}
				/>
			)}
		</>
	);
}

export default TableTemplatePlans;
